import {
  login,
  logout,
  getInfo
} from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {
          const data = response.data
          localStorage.setItem('response',  JSON.stringify(data));
          // const tokenStr = data.tokenHead    +   data.token // 这前面 我可没动
          const tokenStr =  data.token // 这前面 我可没动
          setToken(tokenStr)
          commit('SET_TOKEN', tokenStr)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        let dataAdmin = localStorage.getItem('response');
        dataAdmin = JSON.parse(dataAdmin)

        let response = {
          data: {
            name: "admin",
            roles: '',

          },
        }

        response.data.name = dataAdmin.username;
        response.data.roles = dataAdmin.menus;

        const data = response.data
        localStorage.setItem('roleData',  JSON.stringify(response.data));
          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.roles)
          } else {
            reject('getInfo: roles must be a non-null array !')
          }
          commit('SET_NAME', data.username)
          commit('SET_AVATAR', data.icon)  //头像
          resolve(response)
        // getInfo().then(response => {
        //   const data = response.data
        //   //本地存储账号信息
        //   localStorage.setItem('roleData',  JSON.stringify(response.data));
        //   //通过判断role角色的权限  如果后台没有做权限需要我们在这里判断
        //   if(response.data.role==='super'){
        //     response.data.roles =[100,200,300,400,500,600,700,800,900];
        //   }else if(response.data.role==='agent'){
        //     response.data.roles =[100,200,300,500];
        //   }else{
        //     response.data.roles =[100,200,500];
        //   }
        //
        //   if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
        //     commit('SET_ROLES', data.roles)
        //   } else {
        //     reject('getInfo: roles must be a non-null array !')
        //   }
        //   commit('SET_NAME', data.username)
        //   commit('SET_AVATAR', data.icon)  //头像
        //   resolve(response)
        //
        // }).catch(error => {
        //
        //   reject(error)
        // })
      })
    },


    // 登出
    LogOut({ commit, state }) {

      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {

      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js